// extracted by mini-css-extract-plugin
export var promotionLink = "_vq-0";